import CreatedUserIcon from '../../../../assets/icons/CreatedUser.svg';
import CalendarIcon from '../../../../assets/icons/ACalendar.svg';
import MCQIcon from '../../../../assets/icons/MCQ.svg';
import PracticalIcon from '../../../../assets/icons/Practical.svg';
import AssessmentHeadIcon from '../../../../assets/icons/AssessmentHead.svg';
import Moment from "moment";
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useRef, useState } from 'react';
import { FaEdit, FaEllipsisV, FaTrashAlt } from 'react-icons/fa';
import AuthContext from '../../../../auth/AuthContext';
import AssessmentService from '../../../../services/AssessmentService';
import AlertService from '../../../../services/AlertService';
import ConfirmDialogBox from '../../../confirmDialog/ConfirmDialogBox';
import SharedService from '../../../../services/SharedService';
import { ThemeContext } from '../../../../theme/ThemeContext';

const MasterAssessmentCard = ({ data, onEdit, onDelete }) => {
    const navigate = useNavigate();
    const buttonRef = useRef(null);
    const menuRef = useRef(null);
    const [showMenu, setShowMenu] = useState(false);
    const [dropUp, setDropUp] = useState(false);
    const authContext = useContext(AuthContext);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const toggleMenu = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const dropdownHeight = 100;
            setDropUp(spaceBelow < dropdownHeight);
        }
        setShowMenu(!showMenu);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    
    const handleOpenAssessment = (data) => {
    sessionStorage.setItem("assessmentId", data.id); // store id
    navigate(
    `/masters-assessments/${SharedService.GenerateSlug(data.assessmentName)}`,
    { state: { id: data.id } }
  );
};
    const onConfirmDeleteHandler = (event) => {
        event.preventDefault();
        setShowMenu(false);
        setShowDeleteDialog(true);
    };

    const onDeleteHandler = async () => {
        setShowMenu(false);
        let result = await AssessmentService.Remove(data.id, authContext);
        if (result.isSuccess) {
            AlertService.success("Assessment details are deleted successfully!");
            onDelete();
        } else {
            AlertService.error(result.errorMessage);
        }
    };

    return (
        <div className="card border-0 shadow p-3 p-lg-4 h-100"
            style={{minHeight: "100px" }}
        >
            <div className="d-flex flex-row align-items-center gap-3" style={{ minHeight: '100px' }}>
                <div
                    className="rounded-circle  d-flex justify-content-center align-items-center "
                    style={{ width: "45px", height: "45px", flexShrink: 0 }}
                ><img
                        src={AssessmentHeadIcon}
                        alt="Assessment"
                        className=" me-1"
                    />
                </div>
                <h6 className="mb-0 lh-base">{data.assessmentName}</h6>
                {(onEdit || onDelete) && (
                    <div className="ms-auto" ref={menuRef}>
                        <button
                            className="btn btn-sm border-0"
                            ref={buttonRef}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleMenu();
                            }}
                        >
                            <FaEllipsisV
                                size={18}
                                className="fw-normal"
                                color={isDark ? "#ffffff" : "#000000"}
                            />
                        </button>

                        {showMenu && (
                            <div
                                className={`position-absolute end-0 ${dropUp ? "mb-2 bottom-100" : "mt-2"}`}
                                style={{
                                    minWidth: "160px",
                                    background: "rgba(255, 255, 255, 0.95)",
                                    backdropFilter: "blur(6px)",
                                    borderRadius: "12px",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                                    zIndex: 1000,
                                    padding: "8px 0",
                                }}
                            >
                                {onEdit && (
                                    <button
                                        className="w-100 px-3 py-2 d-flex align-items-center gap-2 text-start border-0 bg-transparent"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowMenu(false);
                                            onEdit(data);
                                        }}
                                        style={{ fontSize: "14px", color: "#333" }}
                                    >
                                        <FaEdit size={14} /> Edit
                                    </button>
                                )}
                                {onDelete && (
                                    <button
                                        className="w-100 px-3 py-2 d-flex align-items-center gap-2 text-start border-0 bg-transparent"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onConfirmDeleteHandler(e);
                                        }}
                                        style={{ fontSize: "14px", color: "#e63946" }}
                                    >
                                        <FaTrashAlt size={14} /> Delete
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
            <hr className='mt-0 mb-3' />

            {/* <div className="progress" style={{ "height": "10px" }}>
                <div className="progress-bar" role="progressbar" style={{ "width": `${data.attendeePercent}%` }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <div className="d-flex justify-content-left mb-3">
                <div className="fw-light" style={{ fontSize: "13px" }}>
                    {data.totalAttendees}/{data.totalUsers}
                </div>
            </div> */}
            <div className="d-flex justify-content-between mb-4">
                <div className="fw-light" title='Created By'>
                    <img
                        src={CreatedUserIcon}
                        alt="Created By"
                        className="w-4 h-4 hover:opacity-70  me-1 mb-1"
                    /> {data.createdByUser}
                </div>
               <div className="fw-light" title='Scheduled On'>
           <img
        src={CalendarIcon}
        alt="Date"
        className="w-4 h-4 hover:opacity-70 me-1 mb-1"
          /> 
       {data.scheduledDate
        ? Moment(data.scheduledDate).isValid()
            ? Moment(data.scheduledDate).format("DD/MM/YYYY")
            : "-"
        : "-"}
       </div>
            </div>
            <div className="d-flex justify-content-between mb-4">
                <div className="fw-light" title='MCQ'>
                    {data.mcq && <><img
                        src={MCQIcon}
                        alt="MCQ"
                        className="w-4 h-4 hover:opacity-70 me-1 mb-1"
                    /> MCQ</>}
                </div>
                <div className="fw-light" title='Practical'>
                    {data.practical && <> <img
                        src={PracticalIcon}
                        alt="Practical"
                        className="w-4 h-4 hover:opacity-70 me-1 mb-1"
                    /> Practical</>}
                </div>
            </div>
            <div className="d-flex justify-content-center mb-1">
                <button
               className="px-5 py-2 rounded-pill btn btn-outline"
              style={{ width: "100%" }}
               onClick={() => handleOpenAssessment(data)}
              >
               Open
              </button>
            </div>
            <ConfirmDialogBox
                visible={showDeleteDialog}
                onHide={() => setShowDeleteDialog(false)}
                onConfirm={() => {
                    setShowDeleteDialog(false);
                    onDeleteHandler();
                }}
                title={
                    <>
                        Are you sure you want to <strong>delete</strong> this assessment?

                    </>
                }
                confirmLabel="Yes, Delete"
                cancelLabel="Cancel"
            />


        </div>
    );
}

export default MasterAssessmentCard